// Remodal
$(function() {
  $('[data-remodal-id]').remodal();
});



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/modal/modal.js